import useCancel from "./useCancel";
import { useContext } from "react";
import CrudModuleFactoryModal from "@beeldit/core/components/CrudModuleFactoryModal";
import { t } from "i18next";
import { CancelActionContext } from "./CancelActionContext";
import usePrepareCancel from "./usePrepareCancel";

function useCancelAction(modelConfig: any, index: any): any {
  const prepareCancel = usePrepareCancel();
  const prepareCancelFunction = (id: any) => prepareCancel(id);

  const onSuccessCancel = () => {
    setShowModal(false);
    index();
  };

  const cancel = useCancel(modelConfig);

  const cancelFunction = () => cancel(onSuccessCancel);

  const contextInstance = useContext(CancelActionContext);
  const { setShowModal } = contextInstance;

  const modalConfig = {
    contextInstance: contextInstance,
    title: "cancel_schedule",
    onSubmit: () => cancelFunction(),
  };

  const actionTemplate = (
    <CrudModuleFactoryModal modalConfig={modalConfig}>
      {t(`are_you_sure_you_want_to_cancel_this_${modelConfig.modelName}?`)}
    </CrudModuleFactoryModal>
  );

  /** END CANCEL ACTION */

  return {
    prepareCancelFunction,
    actionTemplate,
  };
}

export default useCancelAction;
